/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { combineReducers } from 'redux';
import { types } from '../actions/tdm';
import { createAPIReducer } from './api';

const updateNodes = (state = 0, action) => {
  const { type, payload } = action;
  if (type === types.updateNodes) {
    return payload;
  }
  return state;
};
const updateTdmGateways = (state = {}, action) => {
  const { type, payload } = action;
  if (type === types.updateTdmGateways) {
    return payload;
  }
  return state;
};

const getNetwork = createAPIReducer(types.getNetwork);
const setting = createAPIReducer(types.setting);

export default combineReducers({
  setting,
  getNetwork,
  updateNodes,
  updateTdmGateways,
});





// WEBPACK FOOTER //
// ./src/redux/reducers/tdm.js